module.exports = __webpack_public_path__ + "img/de-puydt.4426ca47.png";